export function creditReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_CREDIT":            
        case "UPDATE_CREDIT":
            let list = Object.assign({}, state);
            list[payload.credit_id] = payload
        
            return list
        case "UPDATE_CREDIT_REST":
            let list3 = Object.assign({}, state);
            let rest = list3[payload.credit_src].credit_total_available - payload.credit_amount
            list3[payload.credit_src].credit_total_available = rest
            if (rest > 0) {
                list3[payload.credit_src].available = true
            } else {
                list3[payload.credit_src].available = false
            }
            return list3
            
        case "GET_CREDITS":
            return payload
        case "DELETE_CREDIT":
            let list2 = Object.assign({}, state);
            
            delete list2[payload]
            return list2
        default:
            return state;
    }
    
}